<section class="page">
  <h1>Connexion</h1>
  <form class="card" (ngSubmit)="submit()">
    <label class="field">
      <span>Email</span>
      <input [(ngModel)]="email" type="email" placeholder="nom@exemple.be" name="email" />
    </label>
    <label class="field">
      <span>Mot de passe</span>
      <input [(ngModel)]="password" type="password" placeholder="••••••••" name="password" />
    </label>
    <button class="primary" type="submit" [disabled]="isLoading">
      {{ isLoading ? 'Connexion...' : 'Se connecter' }}
    </button>
    <div class="link-group">
      <a class="link" routerLink="/forgot-password">Mot de passe oublié ?</a>
      <a class="link" routerLink="/register">Créer un compte</a>
    </div>
    <p class="error" *ngIf="errorMessage">{{ errorMessage }}</p>
  </form>
</section>
